/* eslint-env browser */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import classnames from 'classnames';
import { navigationHide } from 'actions';
import has from 'lodash/has';
import findKey from 'lodash/findKey';
import Cookie from 'tiny-cookie';
import auth from 'lib/Auth';

import Icon from 'components/common/Icon';

class Nav extends Component {
  constructor(props) {
    super(props);

    this.navItemSelected = this.navItemSelected.bind(this);
    this.handleMyAccountToggle = this.handleMyAccountToggle.bind(this);
  }

  state = {
    myAccountOpen: false,
  }

  navItemSelected() {
    this.props.navigationHide();
  }

  handleMyAccountToggle() {
    this.setState({ myAccountOpen: !this.state.myAccountOpen });
  }

  render() {
    const { pathname } = this.props.location;

    let activePage = 'inbox';
    if (pathname.indexOf('calendar/add') !== -1) {
      activePage = 'addEvent';
    } else if (pathname.indexOf('calendar') !== -1) {
      activePage = 'calendar';
    } else if (pathname.indexOf('account') !== -1) {
      activePage = 'account';
    } else if (pathname.indexOf('schedule') !== -1) {
      activePage = 'schedule';
    } else if (pathname.indexOf('page') !== -1) {
      activePage = 'page';
    } else if (pathname.indexOf('myTrips') !== -1) {
      activePage = 'myTrips';
    }

    let inboxText = 'Requests';

    if (has(window.CONFIG, 'ui')) {
      if (window.CONFIG.ui === 'card' || window.CONFIG.ui === 'shore2') {
        inboxText = 'Inbox';
      }
    }

    if (has(window.CONFIG, 'enable_dashboard')) {
      if (window.CONFIG.enable_dashboard === '1' || window.CONFIG.enable_dashboard === 1) {
        inboxText = 'Dashboard';
      }
    }

    const { authToken, userId } = auth.getAuthData(this.props.auth);

    let inboxBadge;
    if (has(this.props, 'inbox.count') && this.props.inbox.count > 0) {
      inboxBadge = <span className="badge">{this.props.inbox.count}</span>;
    }

    let isAdmin = false;
    let canAdd = false;
    let canRequest = false;
    let schedulesEnabled = false;
    let pagesEnabled = false;
    const determineCanAddProps = ['add', 'add;basic', 'add;restricted'];
    let facilityRentalsEnabled = false;
    let isDriver = false;

    if (has(this.props, 'auth.data.admin')) {
      if (this.props.auth.data.admin === '1' || this.props.auth.data.admin === 1) {
        isAdmin = true;
        canAdd = true;
      }
    }

    if (has(window.CONFIG, 'enable_reports')) {
      if (window.CONFIG.enable_reports === '1' || window.CONFIG.enable_reports === 1) {
        pagesEnabled = true;
      }
    }

    if (has(window.CONFIG, 'enable_schedules')) {
      if (window.CONFIG.enable_schedules === '1' || window.CONFIG.enable_schedules === 1) {
        schedulesEnabled = true;
      }
    }

    if (has(window.CONFIG, 'enable_facility_requests')) {
      if (window.CONFIG.enable_facility_requests === '1' || window.CONFIG.enable_facility_requests === 1) {

        if (has(window.CONFIG, 'facility_request_show_public')) {
          if (window.CONFIG.facility_request_show_public === '1' || window.CONFIG.facility_request_show_public === 1) {
            facilityRentalsEnabled = true;
          }
        }

        if(!facilityRentalsEnabled) {
          if (has(window.CONFIG, 'facility_request_show_admin')) {
            if (isAdmin && (window.CONFIG.facility_request_show_admin === '1' || window.CONFIG.facility_request_show_admin === 1)) {
              facilityRentalsEnabled = true;
            }
          }
        }
      }
    }

    if (!canAdd && has(this.props, 'auth.data.permissions.object.tfs_Event;events.1')) {
      canAdd = findKey(this.props.auth.data.permissions.object['tfs_Event;events'][1], (value, key) =>
        (value.base === true && determineCanAddProps.indexOf(key) !== -1)
      );
    }

    if (!canAdd && (has(this.props, 'auth.data.permissions.object.tfs_Event;event_requests.1'))) {
      canRequest = findKey(this.props.auth.data.permissions.object['tfs_Event;event_requests'][1], (value, key) =>
        (value.base === true && determineCanAddProps.indexOf(key) !== -1)
      );
    }

    if (has(this.props, 'auth.data.driver')) {
      if (this.props.auth.data.driver === '1' || this.props.auth.data.driver === 1) {
        isDriver = true;
      }
    }

    if (has(this.props, 'auth.data.secondary_driver')) {
      if (this.props.auth.data.secondary_driver === '1' || this.props.auth.data.secondary_driver === 1) {
        isDriver = true;
      }
    }

    const addEvent = (
      <li>
        <Link className={classnames({ active: (activePage === 'addEvent') })} to="/calendar/add" onClick={this.navItemSelected}><Icon icon="add-event" size="medium" />Add Event</Link>
      </li>
    );

    const requestEvent = (
      <li>
        <Link className={classnames({ active: (activePage === 'addEvent') })} to="/calendar/add" onClick={this.navItemSelected}><Icon icon="add-event" size="medium" />Request Event</Link>
      </li>
    );

    const listSchedules = (
      <li>
        <Link className={classnames({ active: (activePage === 'schedule') })} to="/schedule" onClick={this.navItemSelected}><Icon icon="bullet-list" size="medium" />Schedules</Link>
      </li>
    );

    let pagesTitle = 'Report';

    if (has(window.CONFIG, 'enable_reports') && has(window.CONFIG, 'rename_schedules_to_reports')) {
      if (window.CONFIG.enable_reports === '1' && window.CONFIG.rename_schedules_to_reports === '2') {
        pagesTitle = 'Page';
      } else if (window.CONFIG.enable_reports === '1' && window.CONFIG.rename_schedules_to_reports === '1') {
        pagesTitle = 'Report';
      } else if (window.CONFIG.enable_reports === '1') {
        pagesTitle = 'Schedule';
      }
    }

    const listPages = (
      <li>
        <Link className={classnames({ active: (activePage === 'page') })} to="/page" onClick={this.navItemSelected}><Icon icon="pages" size="medium" />{pagesTitle}s</Link>
      </li>
    );

    const myTrips = (
      <li>
        <Link className={classnames({ active: (activePage === 'myTrips') })} to="/myTrips" onClick={this.navItemSelected}><Icon icon="vehicle" size="medium" />My Trips</Link>
      </li>
    );

    const submitFacilityRental = (
      <li>
        <a className={classnames({ active: (activePage === 'facilityRentals') })} href={`${window.DESKTOP_URL}?&mobile=f&type=facility_event&action=add`}><Icon icon="add-event" size="medium" />Submit Facility Rental</a>
      </li>
    );

    const viewMenus = (
      <li>
        <a className={classnames({ active: (activePage === 'viewMenus') })} href={`${window.DESKTOP_URL}?&mobile=f&type=menus&action=month`}><Icon icon="menus" size="medium" />Menus</a>
      </li>
    );

    let enableMenus = false;

    if (has(window.CONFIG, 'enable_menus')) {
      if (window.CONFIG.enable_menus === '1' || window.CONFIG.enable_menus === 1) {
        enableMenus = true;
      }
    }

    const userFullName = has(this.props, 'auth.data.first_name') ? `${this.props.auth.data.first_name} ${this.props.auth.data.last_name}` : '';

    let profileUrl = '';
    if (this.props.auth.data.picture) {
      profileUrl = `${window.API_ROOT}?type=export&action=image&export_type=db_mini&id=${this.props.auth.data.picture}`;
    } else if (this.props.auth.data.facebook_uid) {
      profileUrl = `https://graph.facebook.com/${this.props.auth.data.facebook_uid}/picture?width=40&height=40`;
    }

    let profileImg;
    if(profileUrl != '') {
      profileImg = (<img className="icon medium" src={profileUrl} alt="Profile" />);
    } else {
      profileImg = (<Icon icon="my-profile" size="medium" />);
    }

    const loggedIn = (
      <Link className={classnames({ active: (activePage === 'account') })} to="/account" onClick={this.navItemSelected}>{profileImg}{userFullName} <Icon icon="arrow" size="medium" className="disclosure" /></Link>
    );

    let login = (
      <Link className={classnames({ active: (activePage === 'login') })} to="/login" onClick={this.navItemSelected}><Icon icon="my-profile" size="medium" />Sign In</Link>
    );

    if (has(window.CONFIG, 'enable_workos') && (window.CONFIG.enable_workos === '2')) {
      login = (
        <a className={classnames({ active: (activePage === 'login') })} href={`${window.DESKTOP_URL}?&type=login&action=workos_redirect&ref_mobile=t`}><Icon icon="my-profile" size="medium" />Sign In</a>
      );
    }

    const mainOrg = (
        <a href={`${window.API_ROOT}?&mobile=t&clear_filter=t`}><Icon icon="prev-month" size="medium" />Main Calendar</a>
    );

    let showMainOrg = false;

    let orgName = window.ORG_NAME;

    if(window.SUBDOMAIN != '' || window.ORGANIZATION != '') {
      showMainOrg = true;
    }

    if(typeof window.FILTERS == 'object' && (typeof window.FILTERS.filter_name != 'undefined' || typeof window.FILTERS.exclude_name != 'undefined')) {

      showMainOrg = true;
      
      if(typeof window.FILTERS.filter_name == 'string' && window.FILTERS.filter_name.length > 0) {
        orgName = window.FILTERS.filter_name;
      } else if(typeof window.FILTERS.filter_name == 'object' && window.FILTERS.filter_name.length > 0) {
        orgName = window.FILTERS.filter_name.join(', ');
      }

    }

    /*const loggedIn = (
      <li className={classnames({ 'my-account': true, closed: !this.state.myAccountOpen, open: this.state.myAccountOpen })}>
        <div className="my-info" onClick={this.handleMyAccountToggle}>
          <Icon icon="my-profile" size="medium" />{userFullName} <Icon icon="arrow" size="medium" className="disclosure" />
        </div>
        <div className="my-account-subitems">
          <Link to="/account" onClick={this.navItemSelected}><Icon icon="my-profile" size="medium" />My Profile</Link>
          {
            // <Link to="/account" onClick={this.navItemSelected}><Icon icon="my-organization" size="medium" />My Organization</Link>
            // <Link to="/account" onClick={this.navItemSelected}><Icon icon="upgrade" size="medium" />Upgrade</Link>
            // <Link to="/account" onClick={this.navItemSelected}><Icon icon="get-started" size="medium" />Get Started</Link>
            // <Link to="/account" onClick={this.navItemSelected}><Icon icon="help" size="medium" />Help</Link>
            // <Link to="/logout" onClick={this.navItemSelected}><Icon icon="signout" size="medium" />Sign Out</Link>
          }
        </div>
      </li>
    );*/

    return (
      <nav id="site-nav">
        <h1 dangerouslySetInnerHTML={{ __html: orgName }} />
        <ul>
          {canAdd && addEvent}
          {canRequest && requestEvent}

          {authToken && (
            <li>
              <Link className={classnames({ active: (activePage === 'inbox') })} to="/inbox" onClick={this.navItemSelected}>
                <Icon icon="inbox" size="medium" />{inboxText} {inboxBadge}
              </Link>
            </li>
          )}

          {isDriver && myTrips}

          <li>
            <Link className={classnames({ active: (activePage === 'calendar') })} to="/calendar" onClick={this.navItemSelected}><Icon icon="calendar" size="medium" />Calendar</Link>
          </li>

          {schedulesEnabled && listSchedules}
          {pagesEnabled && listPages}

          {facilityRentalsEnabled && submitFacilityRental}

          {enableMenus && viewMenus}

          {/* 160 is a non-breaking space */}
          {/*<li>{String.fromCharCode(160)}</li>*/}

          {/*
          <li>
            <a href={`${window.DESKTOP_URL}?&mobile=f`}><Icon icon="prev-month" size="medium" />Switch to Desktop View</a>
          </li>
          */}
          <li className={classnames({ 'fixed-bottom': true })}>
            {showMainOrg && mainOrg}
            {authToken ? loggedIn : login}
            {/*<li className="fixed-bottom tandem-logo"><Icon size="primary-logo" icon="tandem-logo" /></li>*/}
          </li>
        </ul>
      </nav>
    );
  }
}

function mapStateToProps(state) {
  const { auth, inbox } = state;
  const { location } = state.router;

  return {
    location,
    auth,
    inbox,
  };
}

export default connect(mapStateToProps, {
  navigationHide,
})(Nav);



// WEBPACK FOOTER //
// ./src/app/components/common/Nav.js